module.exports = __webpack_public_path__ + "img/91.ad5114ad.jpg";